import React from "react";
import styled from "styled-components";
import { Pill, Button, Icon, Dropdown } from "xsolla-uikit";
import { CssClick, CssLineHover, CssTh, CssThTd } from "../uikit2";
import { PApopChangeEmail, PApopChangeDate } from "./PAusersSubscribersPage";
import { getCols, CssNoEmail } from "./PAusersSubsTable";
export function PAuserLine({ columns = [], handleEmail = () => void 0, handleDate = () => void 0, handleClick = () => void 0, handleStop = () => void 0, index, purchase = [], status, type, id = "0299233e-04b9-450c-a2da-3ec3cd5776f8", nickname = null, name = null, picture = null, birthday = null, first_name = null, last_name = null, gender = null, email = null, phone = null, groups = [
  {
    id: 24,
    name: "default",
    is_default: true,
    is_deletable: false
  }
], registered = "2019-09-30T19:02:56+0300", external_id = null, last_login = "2019-09-30T21:53:34+0300", ban = null, country = null, actions }) {
  return (<CssLineHover active={false}
    // hover={false}
    padding="24px 8px 24px 24px">
    <CssTh
      // cols="1.4fr 1fr 2.3fr 3fr 1fr 1fr 1fr"
      cols={getCols(columns)}>
      <CssClick onClick={() => handleClick(index)} />


      {columns.map((oneColName) => {
        switch (oneColName) {
          case 'status':
            return (<div style={{ fontSize: 14 }}>

              <CssThTd>
                <div className="login-user-list-container__user-info__groups" style={{ padding: "5px 0 5px 0" }}>
                  <Dropdown
                    // align="left"
                    autosize={true} size="md"
                    // separated={true}
                    options={[
                      {
                        label: "Stop renewing",
                        description: "The subscription will be active until Oct 28, 2019",
                        customIcon: <Icon name="block" />,
                        onClick: () => handleStop(true),
                        iconAlign: "right"
                      },
                      {
                        label: "Cancel and refund",
                        description: "The user will receive a refund for unused days",
                          customIcon: <Icon name="remove-circle" />,
                        onClick: () => handleStop(true),
                        iconAlign: "right"
                      },{
                        color: "#fc2b55",
                        label: "Cancel whithout refund",
                        // description: (
                        //   <span style={{ color: "#fc2b55" }}>
                        //     User will receive a refund for unused days
                        //   </span>
                        // ),
                        customIcon: (<span style={{ color: "#eb002f" }}>
                          <Icon name="remove-circle" />
                        </span>),
                        iconAlign: "right",
                        onClick: () => handleStop(index)
                      }
                    ]}>

                    <Pill appearance={status["appearance"]}>
                      {status["title"]}
                    </Pill>

                  </Dropdown>
                </div>
              </CssThTd>

            </div>);
          case 'email':
            return (<CssDrop>
              <Dropdown size="lg" type="inform"
                // align="left"
                autosize={true} separated={false} content={{
                  title: "User email",
                  description: <PApopChangeEmail />,
                }}>

                <CssThTd onClick={true}>
                  <div className="login-user-list-container__user-info__email">
                    <div className="login-user-list-container__user-info__groups">
                      {!!email && email}
                      {!email && <CssNoEmail>No email</CssNoEmail>}

                    </div>
                    <div className="login-user-list-container__user-info__id">
                      {id}
                    </div>
                  </div>
                </CssThTd>
              </Dropdown>
            </CssDrop>);
            break;
          case 'internal':
            return (<CssThTd>{purchase[0]["id"]}</CssThTd>);
            break;
          case 'dateCreation':
            return (<CssDrop onClick={e => e.preventDefault()}>
              <Dropdown size="lg" type="inform" align="right" autosize={true} separated={false} content={{
                title: "Next charge date",
                description: <PApopChangeDate />
              }}>
                <CssThTd onClick={true}>
                  <div className="login-user-list-container__user-info__groups">
                    Dec 17, 2019
                          </div>
                  <div className="login-user-list-container__user-info__id">
                    10:17 AM
                          </div>
                </CssThTd>
              </Dropdown>
            </CssDrop>);
            break;
          case 'dateNext':
            return (<CssDrop onClick={e => e.preventDefault()}>
              <Dropdown size="lg" type="inform" align="right" autosize={true} separated={false} content={{
                title: "Next charge date",
                description: <PApopChangeDate />
              }}>
                <CssThTd onClick={true}>
                  <div className="login-user-list-container__user-info__groups">
                    Dec 17, 2019
                          </div>
                  <div className="login-user-list-container__user-info__id">
                    10:17 AM
                          </div>
                </CssThTd>
              </Dropdown>
            </CssDrop>);
            break;
          case 'charge':
            return (<CssThTd>
              <div className="login-user-list-container__user-info__id">
                {purchase[0]["price"]}
              </div>
            </CssThTd>);
            break;
          case 'plan':
            return (<CssThTd>
              <div className="login-user-list-container__user-info__groups">
                {purchase[0]["label"]}
              </div>
              <div className="login-user-list-container__user-info__id">
                {purchase[0]["price"]}
              </div>
            </CssThTd>);
            break;
          case 'action':
            return (<CssThTd style={{
              display: "flex",
              justifyContent: "flex-end",
              fontSize: 14,
              fontWeight: "normal"
            }}>
              <div>
                <Dropdown autosize={true} align="right"
                  // separated={true}
                  options={actions}>
                  <Icon name="more" />
                </Dropdown>
              </div>
            </CssThTd>);
            break;
          default:
            return null;
            break;
        }
      })}





      {columns.indexOf("comment") > -1 && (<CssThTd>
        <div className="login-user-list-container__user-info__id" style={{
          display: "flex",
          justifyContent: "flex-end"
        }}>
          Auto-funding turned off for this subscription
            </div>
      </CssThTd>)}


      {columns.indexOf("info") > -1 && <CssThTd>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <Button onClick={() => handleClick(index)} appearance="flatten" size="sm">

            <div style={{
              fontStyle: "italic",
              fontFamily: "Times",
              backgroundColor: "#0073f7",
              width: 24,
              height: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              borderRadius: 40
            }}>
              i
              </div>
          </Button>
        </div>
      </CssThTd>}





    </CssTh>
  </CssLineHover>);
}
const CssDrop = styled.div`
  & > div {
    padding-bottom: 4px;
  }
  &:hover .xsui-dropdown__item--appearance-row {
    background: transparent;
  }
  & .xsui-dropdown__item__label {
    width: 100%;
  }
`;
